<!--
  DefaultPlanModal.vue
  콜봇 월 정산 · 기본 요율 편집 모달(화면 명세 3 "편집 모달 필드"). [새 버전]과 [수정]이 같이 쓴다.

  요청: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 3", "요청 계약 3-1", 트레이드오프 "자동 확정은 사람이
        보지 않은 금액을 청구 근거로 굳힌다"·"이미 확정된 달은 요율을 고쳐도 바뀌지 않는다"
  칸·본문: ~/md/front/admin-콜봇-월정산-call-api-구현회신.md "2026-10-16 개정 — 요금표 v70" 1(기본 요율 본문·PUT 검증)
  - mode 'create'([새 버전]): 적용 시작 월(기본 다음 달)을 고른다. 그 달 버전이 이미 있으면 그 버전을 고치고, 없으면 그 달
    직전 버전 값을 복사해 연다(직전 버전이 없으면 가장 이른 버전). 아직 아무것도 고치지 않았으면 달을 바꿀 때 그 달 기준
    값으로 다시 채우고, 고친 값이 있으면 지우지 않는다(다시 채우기 링크).
  - mode 'edit'([수정]): 그 버전을 고친다. 적용 시작 월은 읽기 전용.
  - 배치(2026-10-27 목업 RatesEdit.dc.html): 이름 | 입력 | 원가(참고) 세 칸, 칸마다 한 줄 설명. 묶음과 칸 이름은 기본 요율 표
    (SettlementRateCard)와 같다 — 기본(월 사용료 VAT 포함 원 정수 · 포함 통화 분 정수) · 통화 · 10초 단위(120분 초과 통화 1분당 ·
    발신 건당 · 받은 발신 통화 10초당) · 회선 · 웹 텍스트(추가 070 회선·대표번호 회선 월 금액 · 웹 텍스트 원가 그대로 청구 / 청구
    안 함) · 상담사 번호(체크 "이 버전에서 받음" + 기본 포함 · 추가 1개당 VAT 별도) · 메모. 맨 아래 두 줄이 부가세·원가 기준일과
    이 창에 없는 읽기 전용 칸(상담사 연결 원가·부가 항목 — 기본 요율 표의 접힘에서 본다)을 말한다.
    월 사용료·포함 통화·120분 초과·발신은 비울 수 없다(서버 null_not_allowed). 회선 월 금액만 비울 수 있다("미정").
  - 상담사 번호(~/md/front/admin-콜봇-상담사번호-추가요금-프론트요청.md A1): 체크 "이 버전에서 받음"을 켜면
    두 칸(0 이상 정수, 비울 수 없음 — 켤 때 3개·49,000원)을 넣고, 끄면 본문에 `"counselor_number": null` 을 보낸다(늘 보낸다).
    직전 버전에 블록이 없거나 버전이 없·v70 이전 모양이면 꺼진 채로 연다. 끄면 두 칸을 모두 비워(null) 바뀐 칸 비교·닫기 전
    확인이 다른 칸과 같은 식으로 돈다. 일할·최고치를 고르는 스위치는 없다.
    단위 초와 원가는 입력받지 않고 cost_rates 를 회색으로 보인다. 원가가 없는 칸(월 사용료·포함 통화)은 원가 열이 '—'다.
  - 복사·수정할 버전이 요금표 v70 이전 모양(`legacy: true`)이면 칸 값을 요금표 v70 기본값(V70_DEFAULT_PLAN_VALUES)으로
    채워 연다 — 자동 변환은 하지 않고 사람이 보고 저장한다(결정 D1). 회선 일할·부가 항목은 그 버전 값을 잇는다.
  - 검증은 message.warning() — 0 이상의 숫자, 소수 둘째 자리까지, 월 사용료·포함 통화는 정수(validateRateCell).
  - 저장 확인창은 요청 문서 문구 그대로(defaultPlanSaveConfirmText). 확정 정산이 쓴 버전이면 한 문장을, 예전 모양 버전을
    다시 저장하면 풀리는 것을 한 문단 더한다.
  - 바닥 왼쪽: 고칠 버전이면 '바뀐 칸 n개', 새 버전이면 '{복사한 버전} 버전과 다른 칸 n개'(툴팁에 칸 이름).
  - 저장 요청 중에는 닫지 않는다(취소 비활성, X·Esc 무시) — 실패하면 고친 값을 그대로 둔 채 알린다.

  데이터: PUT /api/v1/callbot/billing/default-plans/:effectiveFrom(판매가 칸 + 일할·부가 항목 — formValuesToDefaultPlanBody).
          예전 본문(ai·counselor 판매가)은 400 이다. 성공하면 emit('saved', plan) — 응답이 비면 { effective_from } 만 보낸다.
          다시 불러오기·저장한 버전 고르기는 부모 몫이다.
  props: open · api · plans(모든 버전) · costRates · mode · plan(edit) · initialMonth(create) — emits: close, saved
-->
<template>
  <a-modal :open="open" :footer="null" :mask-closable="false" :width="760" @cancel="requestClose">
    <template #title>
      <div class="modal-title">{{ title }}</div>
    </template>

    <div class="modal-content">
      <div class="plan-form">
        <!-- 적용 시작 월 -->
        <section class="plan-form__section is-month" aria-label="적용 시작 월">
          <div class="plan-form__row">
            <label class="plan-form__label" :for="monthInputId">
              적용 시작 월<em v-if="isCreate" class="plan-form__required" aria-hidden="true">*</em>
            </label>
            <div class="plan-form__body">
              <a-date-picker
                v-if="isCreate"
                :id="monthInputId"
                class="plan-form__month"
                :value="month || null"
                picker="month"
                value-format="YYYY-MM"
                format="YYYY-MM"
                placeholder="적용 시작 월"
                :locale="locale"
                :allow-clear="false"
                :input-read-only="true"
                @change="onPickMonth"
              />
              <span v-else :id="monthInputId" class="plan-form__readonly plan-form__month-text">{{ month }}</span>
            </div>
            <span aria-hidden="true"></span>
            <p v-if="targetText" class="plan-form__hint">{{ targetText }}</p>
            <p v-if="valuesNote" class="plan-form__hint is-warn">
              {{ valuesNote }}
              <button type="button" class="plan-form__link" @click="reseed">그 달 기준 값으로 다시 채우기</button>
            </p>
            <p v-if="startedNote" class="plan-form__hint is-warn">{{ startedNote }}</p>
          </div>

          <a-alert v-if="usedCount > 0" class="plan-form__alert" type="warning" show-icon :message="usedAlert" />
          <a-alert v-if="legacyBase" class="plan-form__alert" type="info" show-icon :message="legacyAlert.message">
            <template #description>
              <span :title="LEGACY_CARRY_TITLE">{{ legacyAlert.description }}</span>
              <span v-if="legacyAlert.summary" class="plan-form__legacy-summary">예전 값 · {{ legacyAlert.summary }}</span>
            </template>
          </a-alert>
        </section>

        <div class="plan-form__colhead" aria-hidden="true"><span>원가 (참고)</span></div>

        <!-- 기본 — 월 사용료 · 포함 통화 -->
        <section class="plan-form__section" :aria-labelledby="`${idPrefix}-base`">
          <h3 :id="`${idPrefix}-base`" class="plan-form__heading">{{ RATE_GROUP_LABELS.base }}</h3>
          <div class="plan-form__fields">
            <RatePriceField
              v-for="key in GROUP_KEYS.base"
              :key="key"
              v-bind="fieldProps[key]"
              :value="values[key]"
              @update:value="setValue(key, $event)"
            />
          </div>
        </section>

        <!-- 통화 — 120분 초과 · 발신 -->
        <section class="plan-form__section" :aria-labelledby="`${idPrefix}-call`">
          <h3 :id="`${idPrefix}-call`" class="plan-form__heading">
            {{ RATE_GROUP_LABELS.call }} <small>· 10초 단위</small>
          </h3>
          <div class="plan-form__fields">
            <RatePriceField
              v-for="key in GROUP_KEYS.call"
              :key="key"
              v-bind="fieldProps[key]"
              :value="values[key]"
              @update:value="setValue(key, $event)"
            />
          </div>
        </section>

        <!-- 회선 · 웹 텍스트 -->
        <section class="plan-form__section" :aria-labelledby="`${idPrefix}-line`">
          <h3 :id="`${idPrefix}-line`" class="plan-form__heading">{{ RATE_GROUP_LABELS.line }} · {{ RATE_GROUP_LABELS.web }}</h3>
          <div class="plan-form__fields">
            <RatePriceField
              v-for="key in GROUP_KEYS.line"
              :key="key"
              v-bind="fieldProps[key]"
              :value="values[key]"
              @update:value="setValue(key, $event)"
            />

            <div class="plan-form__row" role="group" :aria-labelledby="`${idPrefix}-web`">
              <span :id="`${idPrefix}-web`" class="plan-form__label">{{ RATE_CELL_MAP.web_text.label }}</span>
              <div class="plan-form__body">
                <a-radio-group class="plan-form__choice" :value="values.web_text" @change="onWebTextChange">
                  <a-radio :value="true">원가 그대로 청구</a-radio>
                  <a-radio :value="false">청구 안 함</a-radio>
                </a-radio-group>
              </div>
              <span class="plan-form__cost">{{ webCostText || EMPTY }}</span>
              <p class="plan-form__hint">studio 웹 테스트의 텍스트 메시지 · 웹 음성은 포함 통화에 듭니다</p>
            </div>
          </div>
        </section>

        <!-- 상담사 번호 — 블록째 켜고 끈다(끄면 본문에 counselor_number: null) -->
        <section class="plan-form__section" :aria-labelledby="`${idPrefix}-counselor-number`">
          <h3 :id="`${idPrefix}-counselor-number`" class="plan-form__heading">{{ RATE_GROUP_LABELS.counselor_number }}</h3>
          <div class="plan-form__fields">
            <div class="plan-form__row">
              <label class="plan-form__label" :for="counselorSwitchId">추가 번호 요금</label>
              <div class="plan-form__body">
                <a-checkbox :id="counselorSwitchId" :checked="counselorOn" @change="onCounselorToggle">이 버전에서 받음</a-checkbox>
              </div>
              <span aria-hidden="true"></span>
              <p v-if="!counselorOn" class="plan-form__hint">끄면 이 버전에는 상담사 번호 요금이 없습니다</p>
            </div>

            <template v-if="counselorOn">
              <RatePriceField
                v-for="key in GROUP_KEYS.counselor_number"
                :key="key"
                v-bind="fieldProps[key]"
                :value="values[key]"
                @update:value="setValue(key, $event)"
              />
            </template>
          </div>
        </section>

        <!-- 메모 -->
        <section class="plan-form__section">
          <label class="plan-form__heading" :for="memoInputId">메모</label>
          <a-textarea
            :id="memoInputId"
            v-model:value="memo"
            :rows="3"
            :maxlength="MEMO_MAX"
            show-count
            placeholder="예: 2026-11 요금표 반영 — 120분 초과 통화 단가 조정"
          />
        </section>

        <div class="plan-form__note">
          <span>월 사용료만 VAT 포함, 나머지는 부가세 별도입니다 · 원가는 서버 참고값{{ costAsOf ? `(기준일 ${costAsOf})` : '' }}이라 여기서 바꾸지 않습니다.</span>
          <span>구분은 병원 고정(내부·테스트는 그 병원 요율 탭의 예외로) · 상담사 연결 원가 {{ counselorCostCount }}칸 · 부가 항목 {{ extraCount }}개는 읽기 전용이라 기본 요율 표에서 봅니다.</span>
        </div>
      </div>

      <div class="modal-footer">
        <a-tooltip :title="changedTooltip || undefined" placement="topLeft">
          <span class="plan-form__changes">
            {{ changes.lead }}<b v-if="changes.count" class="plan-form__changes-count">{{ changes.count }}</b>
          </span>
        </a-tooltip>
        <a-button :disabled="saving" @click="requestClose">취소</a-button>
        <a-button type="primary" class="yellow-button" :loading="saving" @click="submit">저장</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { computed, getCurrentInstance, h, reactive, ref, watch } from 'vue';
import { Modal, message } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import 'dayjs/locale/ko';

import RatePriceField from './RatePriceField.vue';
import {
  EMPTY,
  addMonths,
  compareMonth,
  currentMonthKst,
  formatNumber,
  isNumber,
  isValidMonth,
  nextMonthKst,
} from '../service/settlementFormat';
import {
  COUNSELOR_COST_ROWS,
  COUNSELOR_NUMBER_DEFAULTS,
  EXTRA_ITEMS,
  RATE_CELLS,
  RATE_CELL_MAP,
  RATE_GROUP_LABELS,
  V70_DEFAULT_PLAN_VALUES,
  cellCostInfo,
  counselorNumberRates,
  defaultPlanSaveConfirmText,
  formValuesToDefaultPlanBody,
  formatCostValue,
  getPath,
  isCostUnknown,
  isLegacyPlan,
  legacyPlanSummary,
  planToFormValues,
  readCell,
  readCellCost,
  tenSecondEquivalentText,
  unitLabel,
  validateRateCell,
} from '../service/settlementRules';
import { parseCallApiError } from '@/views/Callbot/service/callApiError';

const props = defineProps({
  open: { type: Boolean, required: true },
  /** getSettlementApi() */
  api: { type: Object, required: true },
  /** 기본 요율 버전 전부 — 복사할 직전 버전과 같은 달 버전을 찾는다 */
  plans: { type: Array, default: () => [] },
  /** cost_rates(읽기 전용 원가 참고값) */
  costRates: { type: Object, default: null },
  /** 'create'([새 버전]) | 'edit'([수정]) */
  mode: {
    type: String,
    default: 'create',
    validator: (v) => v === 'create' || v === 'edit',
  },
  /** edit: 고칠 버전 */
  plan: { type: Object, default: null },
  /** create: 처음 고른 적용 시작 월(비우면 다음 달 KST) */
  initialMonth: { type: String, default: '' },
});

const emit = defineEmits(['close', 'saved']);

const MEMO_MAX = 500;
const UNAVAILABLE_TEXT = 'call-api 에 기본 요율 API 가 아직 없습니다(배포 전).';

/** 기본 요율에서 고치는 칸(구분 internal 은 false 고정) */
const EDITABLE_KEYS = RATE_CELLS.filter((c) => c.defaultEditable).map((c) => c.key);
/** 숫자 칸 — 웹 텍스트(boolean)를 뺀 나머지 */
const PRICE_KEYS = EDITABLE_KEYS.filter((key) => RATE_CELL_MAP[key].kind !== 'pass_through');
/** 묶음마다 숫자 칸(웹 텍스트는 고르는 칸이라 따로 그린다) */
const GROUP_KEYS = {
  base: PRICE_KEYS.filter((key) => RATE_CELL_MAP[key].group === 'base'),
  call: PRICE_KEYS.filter((key) => RATE_CELL_MAP[key].group === 'call'),
  line: PRICE_KEYS.filter((key) => RATE_CELL_MAP[key].group === 'line'),
  counselor_number: PRICE_KEYS.filter((key) => RATE_CELL_MAP[key].group === 'counselor_number'),
};
/** 상담사 번호 두 칸 — 체크가 켜졌을 때만 쓰고 비울 수 없다(번호 요청 A1) */
const COUNSELOR_KEYS = GROUP_KEYS.counselor_number;
const isCounselorKey = (key) => RATE_CELL_MAP[key]?.group === 'counselor_number';

/**
 * 모달 안 칸 이름 — 기본 요율 표와 같은 이름(RATE_CELLS 의 label). 상담사 번호 두 칸만 묶음 제목이 말하는 '상담사 번호'를
 * 뺀다(검증 문구는 RATE_CELLS 의 이름 그대로)
 */
const FIELD_LABELS = {
  'counselor_number.included': '기본 포함',
  'counselor_number.monthly': '추가 1개당',
};
/** 예전 모양 버전을 다시 저장할 때 잇는 것(안내 툴팁) */
const LEGACY_CARRY_TITLE = '회선 일할·부가 항목은 그 버전 값을 잇습니다.';
const counselorCostCount = COUNSELOR_COST_ROWS.length;
const extraCount = EXTRA_ITEMS.length;

const uid = getCurrentInstance()?.uid ?? 0;
const idPrefix = `st-plan-form-${uid}`;
const monthInputId = `${idPrefix}-month`;
const memoInputId = `${idPrefix}-memo`;
const counselorSwitchId = `${idPrefix}-counselor-switch`;

const asArray = (v) => (Array.isArray(v) ? v : []);

function blankValues() {
  return Object.fromEntries(EDITABLE_KEYS.map((key) => [key, key === 'web_text' ? true : null]));
}

/** 폼 값 정리 — 웹 텍스트는 boolean(없으면 원가 그대로 청구), 나머지는 숫자 또는 null */
function normalizeValue(key, v) {
  if (key === 'web_text') return typeof v === 'boolean' ? v : true;
  return isNumber(v) ? v : null;
}

// ---------------------------------------------------------------------------
// 상태
// ---------------------------------------------------------------------------

const thisMonth = currentMonthKst();
const isCreate = computed(() => props.mode !== 'edit');

const month = ref('');
const values = reactive(blankValues());
const memo = ref('');
/**
 * 저장 대상 — kind: 'existing'(그 달 버전을 고친다) | 'copy'(직전 버전을 복사한 새 버전) |
 * 'copy-after'(그 달 앞 버전이 없어 가장 이른 버전을 복사) | 'blank'(버전이 하나도 없음).
 * base 는 칸 값·부가 항목·회선 일할·원가 스냅샷을 가져오는 버전이다.
 */
const target = ref({ kind: 'blank', plan: null, base: null });
/** 지금 칸 값을 채운 버전(적용 시작 월). null = 요금표 v70 기본값 */
const valuesFrom = ref(null);
/** 채운 직후의 값 — 사람이 고쳤는지(dirty) 가른다 */
const seedSnapshot = ref('');
const saving = ref(false);
/** 상담사 번호 요금 체크 — 꺼지면 두 칸은 null 이고 본문은 `counselor_number: null` */
const counselorOn = ref(false);

/** 적용 시작 월 오름차순 */
const sortedPlans = computed(() =>
  asArray(props.plans)
    .filter((p) => isValidMonth(p?.effective_from))
    .sort((a, b) => compareMonth(a.effective_from, b.effective_from))
);

/** 그 달에 저장하면 무엇을 고치거나 복사하는가 */
function resolveTarget(m) {
  const list = sortedPlans.value;
  const existing = list.find((p) => p.effective_from === m);
  if (existing) return { kind: 'existing', plan: existing, base: existing };
  const before = [...list].reverse().find((p) => compareMonth(p.effective_from, m) < 0);
  if (before) return { kind: 'copy', plan: null, base: before };
  const after = list.find((p) => compareMonth(p.effective_from, m) > 0);
  if (after) return { kind: 'copy-after', plan: null, base: after };
  return { kind: 'blank', plan: null, base: null };
}

// 체크도 넣는다 — 켠 채 두 칸을 비우면 꺼짐(두 칸 null)과 값이 같아도 저장하지 않은 입력이다
function snapshotOf(vals, memoText, counselor = counselorOn.value) {
  return JSON.stringify({
    v: EDITABLE_KEYS.map((key) => normalizeValue(key, vals[key])),
    c: !!counselor,
    m: typeof memoText === 'string' ? memoText.trim() : '',
  });
}

const dirty = computed(() => snapshotOf(values, memo.value) !== seedSnapshot.value);

/**
 * 칸 값을 채운다 — 버전이 없거나 요금표 v70 이전 모양이면 요금표 v70 기본값으로(자동 변환하지 않고 사람이 보고 저장한다).
 * 상담사 번호 체크는 복사·수정할 버전에 블록이 있을 때만 켠다(v70 기본값·블록 없는 버전은 꺼짐 — 번호 요청 A1)
 */
function fillFrom(base) {
  const fromPlan = !!base && !isLegacyPlan(base);
  const next = fromPlan ? planToFormValues(base) : V70_DEFAULT_PLAN_VALUES;
  for (const key of EDITABLE_KEYS) values[key] = normalizeValue(key, next[key]);
  counselorOn.value = fromPlan && counselorNumberRates(base) !== null;
  if (!counselorOn.value) for (const key of COUNSELOR_KEYS) values[key] = null;
  valuesFrom.value = fromPlan ? base.effective_from : null;
}

function applyTarget(t, { refill = true } = {}) {
  target.value = t;
  if (!refill) return;
  fillFrom(t.base);
  memo.value = t.kind === 'existing' && typeof t.plan?.memo === 'string' ? t.plan.memo : '';
  seedSnapshot.value = snapshotOf(values, memo.value);
}

// 열릴 때마다 처음부터 — 닫았다 다시 열면 이전 입력이 남지 않게
function init() {
  if (!isCreate.value && props.plan && isValidMonth(props.plan.effective_from)) {
    month.value = props.plan.effective_from;
    // 목록을 다시 받은 뒤라면 같은 달의 새 값(확정 정산 수 포함)을 쓴다
    const fresh = sortedPlans.value.find((p) => p.effective_from === month.value) ?? props.plan;
    applyTarget({ kind: 'existing', plan: fresh, base: fresh });
    return;
  }
  month.value = isValidMonth(props.initialMonth) ? props.initialMonth : nextMonthKst();
  applyTarget(resolveTarget(month.value));
}

watch(
  () => props.open,
  (open) => {
    if (open) init();
  },
  { immediate: true }
);

function onPickMonth(next) {
  if (!isValidMonth(next) || next === month.value) return;
  const keepEdits = dirty.value;
  month.value = next;
  // 아직 고친 것이 없으면 그 달 기준 값으로 다시 채우고, 고친 값이 있으면 지우지 않는다
  applyTarget(resolveTarget(next), { refill: !keepEdits });
}

function reseed() {
  applyTarget(target.value);
}

function setValue(key, v) {
  values[key] = normalizeValue(key, v);
}

function onWebTextChange(event) {
  const v = event?.target?.value;
  if (typeof v === 'boolean') values.web_text = v;
}

/** 상담사 번호 체크 — 켜면 3개·49,000원으로 채우고, 끄면 두 칸을 비운다(본문 `counselor_number: null`) */
function onCounselorToggle(eventOrChecked) {
  const checked = typeof eventOrChecked === 'boolean' ? eventOrChecked : !!eventOrChecked?.target?.checked;
  counselorOn.value = checked;
  values['counselor_number.included'] = counselorOn.value ? COUNSELOR_NUMBER_DEFAULTS.included : null;
  values['counselor_number.monthly'] = counselorOn.value ? COUNSELOR_NUMBER_DEFAULTS.monthly : null;
}

// ---------------------------------------------------------------------------
// 안내 문구
// ---------------------------------------------------------------------------

const title = computed(() => {
  if (!isCreate.value || target.value.kind === 'existing') {
    return isValidMonth(month.value) ? `기본 요율 ${month.value} 버전 수정` : '기본 요율 버전 수정';
  }
  return '기본 요율 새 버전';
});

/** 고칠 버전을 쓴 확정 정산 수(새 버전은 0) */
const usedCount = computed(() => {
  const t = target.value;
  return t.kind === 'existing' && isNumber(t.plan?.confirmed_statements) ? t.plan.confirmed_statements : 0;
});

/** 복사·수정할 버전이 요금표 v70 이전 모양이다 — 칸 값은 요금표 v70 기본값으로 채웠다 */
const legacyBase = computed(() => isLegacyPlan(target.value.base));

const legacyAlert = computed(() => {
  const base = target.value.base;
  if (!legacyBase.value) return { message: '', description: '', summary: '' };
  const from = base.effective_from;
  const existing = target.value.kind === 'existing';
  return {
    message: existing
      ? `${from} 버전은 요금표 v70 이전 모양이라 이 버전이 적용되는 달은 금액을 계산하지 않습니다.`
      : `복사할 ${from} 버전이 요금표 v70 이전 모양입니다.`,
    description: '칸 값을 요금표 v70 기본값으로 채웠습니다. 확인하고 저장하면 새 칸으로 바뀝니다(자동으로 바꾸지 않습니다).',
    summary: legacyPlanSummary(base).join(' · '),
  };
});

/** 이 버전이 쓰일 달 — 다음(더 늦은) 버전 전 달까지 */
const rangeText = computed(() => {
  const m = month.value;
  if (!isValidMonth(m)) return '';
  const newer = sortedPlans.value.find((p) => compareMonth(p.effective_from, m) > 0);
  const to = newer ? addMonths(newer.effective_from, -1) : null;
  if (to === null) return `${m}부터`;
  return to === m ? m : `${m} ~ ${to}`;
});

const targetText = computed(() => {
  const m = month.value;
  if (!isValidMonth(m)) return '';
  const t = target.value;
  const used = `이 버전으로 확정한 정산 ${formatNumber(usedCount.value)}건`;
  if (!isCreate.value) return `적용 ${rangeText.value} · ${used}`;
  switch (t.kind) {
    case 'existing':
      return `${m} 버전이 이미 있어 그 버전을 고칩니다 · 적용 ${rangeText.value} · ${used}`;
    case 'copy':
      return `${t.base.effective_from} 버전 값을 복사해 시작합니다 · 적용 ${rangeText.value}`;
    case 'copy-after':
      return `${m} 이전 버전이 없어 가장 이른 ${t.base.effective_from} 버전 값을 복사했습니다 · 적용 ${rangeText.value}`;
    default:
      return '기본 요율 버전이 하나도 없어 요금표 v70 기본값으로 시작합니다';
  }
});

/** 달을 바꿨지만 고친 값을 지우지 않아 칸 값이 다른 버전 기준일 때 */
const valuesNote = computed(() => {
  if (!isCreate.value) return '';
  const base = target.value.base;
  const want = base && !isLegacyPlan(base) ? base.effective_from : null;
  if (valuesFrom.value === want) return '';
  const from = valuesFrom.value ? `${valuesFrom.value} 버전` : '요금표 v70 기본값';
  return `입력한 값을 지우지 않으려고 칸 값을 ${from} 기준으로 두었습니다.`;
});

/** 이미 시작된 달부터 적용되는 버전 — 저장하면 확정 전인 달의 금액이 바로 바뀐다 */
const startedNote = computed(() =>
  isValidMonth(month.value) && compareMonth(month.value, thisMonth) <= 0
    ? '이미 시작된 달부터 쓰는 버전이라 저장하면 확정 전인 달(추정 중)의 금액이 바로 바뀝니다.'
    : ''
);

const usedAlert = computed(
  () =>
    `이 버전을 쓴 확정 정산 ${formatNumber(usedCount.value)}건은 바뀌지 않습니다. 이미 쓰인 단가를 바꾸면 같은 달에 병원마다 다른 단가가 적용됩니다. 단가를 바꾸려면 다음 달 버전을 만드세요.`
);

const costAsOf = computed(() => (typeof props.costRates?.as_of === 'string' ? props.costRates.as_of : ''));

// ---------------------------------------------------------------------------
// 칸 — 원가·단위(cost_rates 우선, 없으면 버전의 원가 스냅샷), 보조 설명
// ---------------------------------------------------------------------------

function prorateText(lineKey) {
  return getPath(target.value.base, ['line', lineKey, 'prorate']) === false ? '일할 없음 · ' : '';
}

/** 회선을 비울 때의 뜻 — 두 회선이 같다 */
const LINE_UNSET_HINT = '비우면 미정 — 그 회선이 있는 병원은 자동 마감이 검토 필요로 멈춥니다';

/** 칸 아래 한 줄 설명 — 긴 계산 규칙은 기본 요율 표의 '계산 방법' 툴팁이 말한다 */
function fieldHint(key) {
  switch (key) {
    case 'base.monthly': {
      const fee = values['base.monthly'];
      if (!isNumber(fee)) return 'VAT 포함 금액 · 원 단위 정수';
      const supply = Math.floor((fee * 10) / 11);
      return `VAT 포함 금액 · 공급가액 ${formatNumber(supply)}원 + 부가세 ${formatNumber(fee - supply)}원`;
    }
    case 'base.minutes':
      return '수신 통화와 웹 음성 · 개통 달은 일할';
    case 'inbound.overage': {
      const minutes = values['base.minutes'];
      const tenSec = tenSecondEquivalentText(values['inbound.overage']);
      const lead = isNumber(minutes) ? `${formatNumber(minutes)}분을 넘은 10초 단위만` : '포함 통화를 넘은 10초 단위만';
      return tenSec ? `${lead} · ${tenSec}` : lead;
    }
    case 'outbound.per_call':
      return '무응답·음성사서함 포함 · 걸기 전 취소는 0원';
    case 'outbound.unit':
      return '환자가 받은 발신 통화만';
    case 'line.070':
    case 'line.uan':
      return `${prorateText(key === 'line.uan' ? 'uan' : '070')}${LINE_UNSET_HINT}`;
    // 상담사 번호(번호 요청 A1) — 병원이 내는 돈(1개당)은 입력한 공급가에 부가세(10%, 원 미만 절사)를 더해 보인다
    case 'counselor_number.included':
      return '일반·착신전환·링그룹·내선 번호를 모두 셉니다';
    case 'counselor_number.monthly': {
      const monthly = values['counselor_number.monthly'];
      const paid = isNumber(monthly) ? `(병원은 ${formatNumber(monthly + Math.floor(monthly / 10))}원)` : '';
      return `VAT 별도${paid} · 등록된 날만큼 일할 · 계약 상한 밖`;
    }
    default:
      return '';
  }
}

/** 입력 앞 단위 — 월 사용료·회선·상담사 번호 1개당은 '월', 발신은 '건당', 10초 단가는 '10초당', 포함 통화·번호 수는 없음 */
function unitTextOf(key, unitSec) {
  const kind = RATE_CELL_MAP[key].kind;
  if (kind === 'fee' || kind === 'monthly' || kind === 'monthly_excl') return '월';
  if (kind === 'per_call') return '건당';
  if (kind === 'per_minute') return '1분당';
  if (kind === 'minutes' || kind === 'count') return '';
  return `${unitLabel(unitSec ?? 10, key)}당`;
}

/** 입력 뒤 단위 — 포함 통화는 '분', 상담사 번호 기본 포함 수는 '개', 나머지는 '원' */
function suffixOf(key) {
  const kind = RATE_CELL_MAP[key].kind;
  if (kind === 'minutes') return '분';
  if (kind === 'count') return '개';
  return '원';
}

function buildFieldProps(key) {
  const cell = RATE_CELL_MAP[key];
  // 오늘 원가(cost_rates)를 보고 판매가를 정한다 — cost_rates 에 칸이 없으면 이 버전에 실린 원가 스냅샷, 그것도 없으면
  // null(원가 줄 없음 — 월 사용료·포함 통화는 원가가 없다)
  const info = cellCostInfo(key, { costRates: props.costRates, source: target.value.base, prefer: 'live' });
  const locked = !!info && isCostUnknown(key, info);
  const unitSec = readCell(target.value.base, key).unitSec ?? info?.unitSec ?? null;

  // 원가 열 머리가 '원가 (참고)'라 '원가' 를 붙이지 않는다
  let costText = '';
  if (info && !locked) {
    const text = formatCostValue(key, info);
    if (text !== EMPTY) costText = text;
  }

  return {
    label: FIELD_LABELS[key] ?? cell.label,
    unitText: unitTextOf(key, unitSec),
    suffix: suffixOf(key),
    step: cell.kind === 'fee' ? 1000 : 1,
    cost: !locked && isNumber(info?.cost) ? info.cost : null,
    costText,
    locked,
    // 상담사 번호 두 칸은 체크를 켰을 때만 보이고, 켜져 있으면 비울 수 없다
    required: cell.requiredInDefault || isCounselorKey(key),
    // 상담사 번호에는 '미정'이 없다(번호 요청 A1) — 비운 칸에 '미정'을 띄우지 않는다. 나머지 칸은 RatePriceField 기본값('미정')
    emptyText: isCounselorKey(key) ? '' : undefined,
    hint: fieldHint(key),
    mode: 'default',
  };
}

const fieldProps = computed(() => Object.fromEntries(PRICE_KEYS.map((key) => [key, buildFieldProps(key)])));

const webCostText = computed(() => {
  const info = readCellCost(props.costRates, 'web_text');
  const text = formatCostValue('web_text', info);
  return text === EMPTY ? '' : text;
});

// ---------------------------------------------------------------------------
// 바뀐 칸 — 저장 대상 버전(고칠 버전 또는 복사한 버전)과 견준다
// ---------------------------------------------------------------------------

/**
 * 보낼 값 — 원가를 모르는 칸은 판매가를 넣을 수 없어(서버 400) 언제나 미정으로 보낸다. 상담사 번호 체크가 꺼졌으면 두 칸은
 * null 이다(본문 `counselor_number: null` — formValuesToDefaultPlanBody)
 */
const payloadValues = computed(() => {
  const out = {};
  for (const key of EDITABLE_KEYS) {
    if (isCounselorKey(key) && !counselorOn.value) out[key] = null;
    else out[key] = fieldProps.value[key]?.locked ? null : normalizeValue(key, values[key]);
  }
  return out;
});

const changedKeys = computed(() => {
  const base = target.value.base && !legacyBase.value ? planToFormValues(target.value.base) : blankValues();
  return EDITABLE_KEYS.filter((key) => payloadValues.value[key] !== normalizeValue(key, base[key]));
});

const memoChanged = computed(() => {
  const t = target.value;
  const before = t.kind === 'existing' && typeof t.plan?.memo === 'string' ? t.plan.memo.trim() : '';
  return memo.value.trim() !== before;
});

/** 바닥 왼쪽 — lead 뒤에 굵은 개수(count, 없으면 '') */
const changes = computed(() => {
  const t = target.value;
  const n = changedKeys.value.length;
  // 예전 모양 버전은 칸끼리 견줄 수 없다 — 새 칸으로 다시 저장한다
  if (legacyBase.value) {
    return { lead: t.kind === 'existing' ? '새 칸으로 다시 저장(v70 이전 모양 → 요금표 v70)' : '요금표 v70 기본값에서 시작', count: '' };
  }
  if (t.kind === 'existing') {
    if (n) return { lead: '바뀐 칸', count: `${formatNumber(n)}개` };
    return { lead: memoChanged.value ? '메모만 바뀜' : '바뀐 칸 없음', count: '' };
  }
  if (!t.base) return { lead: '', count: '' };
  return { lead: `${t.base.effective_from} 버전과 다른 칸`, count: `${formatNumber(n)}개` };
});

const changedTooltip = computed(() =>
  legacyBase.value ? '' : changedKeys.value.map((key) => RATE_CELL_MAP[key].label).join(', ')
);

// ---------------------------------------------------------------------------
// 저장 · 닫기
// ---------------------------------------------------------------------------

function submit() {
  if (saving.value) return;
  const m = month.value;
  if (!isValidMonth(m)) {
    message.warning('적용 시작 월을 고르세요.');
    return;
  }
  for (const key of PRICE_KEYS) {
    if (fieldProps.value[key].locked) continue;
    // 상담사 번호 두 칸은 체크를 켰을 때만 검사한다 — 켜져 있으면 비울 수 없고 0 이상 정수다(번호 요청 A1)
    if (isCounselorKey(key) && !counselorOn.value) continue;
    const required = RATE_CELL_MAP[key].requiredInDefault || isCounselorKey(key);
    const error = validateRateCell(key, values[key], { required });
    if (error) {
      message.warning(error);
      return;
    }
  }
  // 예전 모양 버전은 칸이 같아 보여도 새 칸으로 다시 저장해야 풀린다
  if (target.value.kind === 'existing' && !legacyBase.value && !changedKeys.value.length && !memoChanged.value) {
    message.warning('바뀐 내용이 없습니다.');
    return;
  }
  const lead = defaultPlanSaveConfirmText(usedCount.value);
  const legacyLine =
    target.value.kind === 'existing' && legacyBase.value
      ? `저장하면 이 버전이 적용되는 달의 "기본 요율 없음(v70 이전 모양)"이 풀립니다. 검토 필요인 정산은 [다시 계산], 확정된 정산은 [재수정] → [다시 계산] → [확정]해야 새 항목으로 바뀝니다.`
      : '';
  Modal.confirm({
    title: `기본 요율 ${m} 버전 저장`,
    content: legacyLine ? h('div', [h('p', { style: 'margin: 0 0 8px;' }, lead), h('p', { style: 'margin: 0;' }, legacyLine)]) : lead,
    okText: '저장',
    cancelText: '취소',
    onOk: () => save(m),
  });
}

async function save(m) {
  saving.value = true;
  try {
    const body = formValuesToDefaultPlanBody(payloadValues.value, { base: target.value.base, memo: memo.value });
    const saved = await props.api.putDefaultPlan(m, body);
    message.success(`기본 요율 ${m} 버전을 저장했습니다.`);
    emit('saved', saved ?? { effective_from: m });
  } catch (err) {
    message.error(parseCallApiError(err, '기본 요율을 저장하지 못했습니다.', { unavailableMessage: UNAVAILABLE_TEXT }));
  } finally {
    saving.value = false;
  }
}

// 저장 요청 중에는 닫지 않는다(취소·X·Esc 모두) — 실패하면 고친 값을 그대로 둔 채 알려야 한다
function requestClose() {
  if (saving.value) return;
  if (!dirty.value) {
    emit('close');
    return;
  }
  Modal.confirm({
    title: '편집을 닫을까요?',
    content: '저장하지 않은 입력이 있습니다. 닫으면 입력한 값은 사라집니다.',
    okText: '닫기',
    okType: 'danger',
    cancelText: '계속 편집',
    onOk: () => emit('close'),
  });
}
</script>

<style scoped lang="scss">
@use '../styles/settlement' as *;

@include st-modal;
@include yellow-button;

.plan-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 4px;
  font-size: 13px;
  color: $st-text;

  &__section {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 14px;

    &.is-month {
      gap: 8px;
      margin-top: 0;
    }
  }

  &__heading {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b4450;

    small {
      font-size: 13px;
      font-weight: 400;
      color: $st-muted;
    }
  }

  // RatePriceField 와 같은 세 칸 격자(이름 | 입력 | 원가)
  &__fields {
    display: flex;
    flex-direction: column;

    > * {
      border-bottom: 1px solid $st-border;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: minmax(110px, 150px) minmax(0, 1fr) 110px;
    gap: 4px 16px;
    align-items: start;
    padding: 10px 0;

    > .plan-form__hint {
      grid-column: 2 / 4;
    }
  }

  // '원가 (참고)' 열 머리 — RatePriceField 의 오른쪽 열 위
  &__colhead {
    display: flex;
    justify-content: flex-end;
    margin-top: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 12px;
    color: $st-muted;

    span {
      width: 110px;
      text-align: right;
    }
  }

  &__label {
    margin: 0;
    padding-top: 5px;
    font-size: 13.5px;
    font-weight: 600;
    color: $st-text;
    word-break: keep-all;
  }

  &__required {
    margin-left: 2px;
    font-style: normal;
    color: $st-danger;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    min-width: 0;
    padding-top: 2px;
  }

  &__month {
    width: 180px;
  }

  &__readonly {
    display: inline-block;
    padding: 4px 10px;
    border: 1px solid $st-border;
    border-radius: 8px;
    background: $st-bg;
    color: $st-text-secondary;
  }

  &__month-text {
    font-weight: 700;
    color: $st-text;
    @include st-num;
  }

  &__hint {
    margin: 0;
    font-size: 12.5px;
    line-height: 1.5;
    color: $st-muted;

    &.is-warn {
      color: $st-warning;
    }
  }

  &__cost {
    padding-top: 5px;
    color: $st-muted;
    font-size: 13px;
    text-align: right;
    @include st-num;
  }

  // 글자 버튼 — 전역 common.scss 의 `button { height: 40px }` 를 끈다
  &__link {
    height: auto;
    margin-left: 4px;
    padding: 0;
    border: 0;
    background: none;
    color: $st-accent;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid $st-accent;
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  &__alert {
    font-size: 12.5px;
  }

  // 예전 모양 버전의 저장된 값 — 안내 아래 한 줄
  &__legacy-summary {
    display: block;
    margin-top: 4px;
    color: $st-muted;
  }

  &__choice {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    padding-top: 3px;
  }

  // 맨 아래 두 줄 — 부가세·원가 기준일, 이 창에 없는 읽기 전용 칸
  &__note {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 18px;
    padding: 10px 14px;
    border-radius: 8px;
    background: $st-bg;
    font-size: 12.5px;
    line-height: 1.5;
    color: $st-text-secondary;
  }

  &__changes {
    margin-right: auto;
    align-self: center;
    font-size: 13px;
    color: $st-text-secondary;
    cursor: default;
  }

  &__changes-count {
    // The gap is a margin — a leading space inside <b> does not survive the template whitespace handling
    margin-left: 4px;
    color: $st-text;
    @include st-num;
  }

  // 좁은 화면 — 한 칸으로 쌓는다
  @media (max-width: 560px) {
    &__row {
      grid-template-columns: minmax(0, 1fr);

      > .plan-form__hint {
        grid-column: auto;
      }
    }

    &__cost {
      padding-top: 0;
      text-align: left;
    }

    &__colhead {
      display: none;
    }
  }
}
</style>
